import { computed } from 'vue'
import { useDisplay } from 'vuetify'

export function useMobile() {
  const { smAndDown } = useDisplay() // Vuetify's useDisplay composable
  const isMobile = computed(() => smAndDown.value)
  return { isMobile }
}
